import { useEffect, useState } from 'react';
import { Boton, Campo, FilaAcciones } from '../../ui/base';
import { Modal } from '../../ui/Modal';

/** Crea el pedido siguiente. Siempre es «Pedido N»; el nombre opcional lo acompaña: «Pedido 1: Juan». */
export function NuevoPedido({
  abierto,
  numero,
  llevaMostrador,
  onGuardar,
  onCerrar,
}: {
  abierto: boolean;
  /** El número que tendrá el pedido nuevo. */
  numero: number;
  /** Hay productos en MOSTRADOR: pasan al pedido nuevo. */
  llevaMostrador: boolean;
  onGuardar: (nombre: string | null) => void;
  onCerrar: () => void;
}) {
  const [nombre, setNombre] = useState('');
  useEffect(() => {
    if (abierto) setNombre('');
  }, [abierto]);

  return (
    <Modal abierto={abierto} titulo="Nuevo pedido" onCerrar={onCerrar}>
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          onGuardar(nombre.trim() || null);
        }}
        data-e2e="ventana-nuevo-pedido"
      >
        <Campo
          etiqueta="Nombre (opcional)"
          placeholder="Juan, mesa 4…"
          maxLength={40}
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          data-e2e="nuevo-pedido-nombre"
        />
        <p className="text-muted text-contenido">
          Se crea «Pedido {numero}»{nombre.trim() ? `: ${nombre.trim()}` : ''}.
          {llevaMostrador ? ' Lo escaneado en MOSTRADOR pasa a este pedido.' : ''}
        </p>
        <FilaAcciones>
          <Boton variante="contorno" type="button" onClick={onCerrar}>
            Cancelar
          </Boton>
          <Boton type="submit" data-e2e="nuevo-pedido-guardar">
            Crear pedido
          </Boton>
        </FilaAcciones>
      </form>
    </Modal>
  );
}
